<template>
  <auth-layout>
    <div class="w-full md:w-4/5 mx-auto text-darkBlue">
      <div class="w-full md:w-9/12 mx-auto mt-4">
        <p class="text-sm text-2xl font-semibold">
          Answer your security question.
        </p>
        <form class="auth-code-form mt-4" @submit.prevent>
          <div class="mx-auto w-full">
            <label class="label capitalize">{{ user.securityques }}</label>

            <base-input v-model="answer" placeholder="Enter your answer" />
          </div>

          <div class="mt-10 mb-8">
            <base-button
              text="Submit"
              width="w-full"
              p="px-12 py-2"
              @click="confirmAnswer"
            />
          </div>
        </form>
      </div>
    </div>

    <template v-slot:text>
      <div class="text-white">
        <p class="text-sm">
          One last step and you are all good to go. Provide the answer for your
          security question!
        </p>
      </div>
    </template>
  </auth-layout>
</template>

<script>
import AuthLayout from "../Authlayout/OnDemand";

export default {
  components: {
    AuthLayout,
  },

  data() {
    return {
      answer: "",
      user: {},
    };
  },
  computed: {
    // securityQuestion() {
    //   let user = JSON.parse(localStorage.getItem("loggedInUser"));
    //   if (user) {
    //     return user.securityques;
    //   } else {
    //     return "";
    //   }
    // },
  },
  mounted() {
    let loginPayload = JSON.parse(localStorage.getItem("loginPayload"));
    if (loginPayload) {
      this.user = loginPayload.data.users;
    } else {
      this.$router.push("/");
    }
  },
  methods: {
    confirmAnswer() {
      if (this.answer.toLowerCase() == this.user.answer.toLowerCase()) {
        let loginPayload = JSON.parse(localStorage.getItem("loginPayload"));
        this.$store.dispatch("handleSuccessfulLogin", loginPayload);
        const { users } = loginPayload.data;
        localStorage.removeItem("loginPayload");

        if (users.onboardingtype == "ondemand") {
          this.$router.push("/dashboard");
        } else {
          this.$router.push("/3pl/dashboard");
        }
      } else {
        this.generateToast("Wrong answer!", "error");
      }
    },
  },
};
</script>

<style scoped></style>
